// xmas点击tab跳转对应模块
let currentPage = window.location.href
if(currentPage.search('/xmas-sale-2024') != -1){
  $(function(){
    let fixedTypeName = ''
    setTimeout(()=>{
        $(".AKXmasTab_fixed ul li").click(function(){
          $(this).addClass("active").siblings().removeClass("active")
          fixedTypeName = $(this).attr("data-type")
          $('html,body').animate({scrollTop:$(`#${fixedTypeName}`).offset().top-110}, 800);
      })
    },800)
  })
}

// header 菜单鼠标悬浮
$(function(){
  function setMegaMenuTop() {
    var $wrapper = $('.header-wrapper');
    if (!$wrapper.length) return;
    var bottom = $wrapper[0].getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--site-header-bottom', bottom + 'px');
  }

  function initDesktopMegaMenu() {
    if (window.screen.width <= 1024) return;

    setMegaMenuTop();

    var hideTimer;
    var $grandparent = $('.header--desktop .main-menu > .grandparent');
    var $dropdown = $grandparent.children('.main-menu-dropdown');

    function showMegaMenu() {
      clearTimeout(hideTimer);
      setMegaMenuTop();
      $dropdown.show();
    }

    function hideMegaMenu() {
      hideTimer = setTimeout(function() {
        $dropdown.hide();
      }, 120);
    }

    $grandparent.off('.megaMenu').on('mouseenter.megaMenu', showMegaMenu).on('mouseleave.megaMenu', hideMegaMenu);
    $dropdown.off('.megaMenu').on('mouseenter.megaMenu', showMegaMenu).on('mouseleave.megaMenu', hideMegaMenu);

    $('.header--desktop .main-menu > .grandparent > .main-menu-dropdown > .w1280 > ul > li.parent:first-child').addClass('main-menu--active');
    $('.header--desktop .main-menu-dropdown li.parent').off('.megaMenu').on('mouseenter.megaMenu', function(){
      $(this).addClass('main-menu--active').siblings().removeClass('main-menu--active');
    });

    $(window).off('.megaMenu').on('resize.megaMenu load.megaMenu', setMegaMenuTop).on('scroll.megaMenu', function(){
      if (window.pageYOffset >= 80) {
        clearTimeout(hideTimer);
        $dropdown.hide();
      }
      setMegaMenuTop();
    });
  }

  initDesktopMegaMenu();

  if(window.screen.width <= 1024){
    $(".touch__nav__links li.parent").removeClass("main-menu--active")
    $(".main-menu-dropdown li.parent").click(function(){
      $(this).find(".main-menu-child").slideToggle()
      $(this).addClass("main-menu--active").siblings().removeClass("main-menu--active")
      $(this).siblings().find(".main-menu-child").slideUp()
      $(this).siblings().find(".ariaToggle").attr("aria-expanded",false)
    })
  }
})
